// extracted by mini-css-extract-plugin
export default {"window":"Window_window__GReKs","content":"Window_content__svFU-"};